import * as icons from '../icon';
import { SupportedPlugins, TemplateOptions } from './providers.types';

const svgBackground = `
<div class='svg-preview'>
  <img class='svg-preview__content' alt='consent preview' src='data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic3ZnLXByZXZpZXdfX2NvbnRlbnQiIHdpZHRoPSIxMDAlIiB2aWV3Qm94PSIwIDAgNDc4IDU1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgICAgPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIyOCIgY3k9IjUwNyIgcj0iMTciIGZpbGw9ImJsYWNrIi8+CiAgICAgIDxyZWN0IG9wYWNpdHk9IjAuMSIgeD0iNTciIHk9IjQ5MyIgd2lkdGg9IjE2MiIgaGVpZ2h0PSIxMiIgZmlsbD0iYmxhY2siLz4KICAgICAgPHJlY3Qgb3BhY2l0eT0iMC4xIiB4PSI1NyIgeT0iNTA5IiB3aWR0aD0iODgiIGhlaWdodD0iMTIiIGZpbGw9ImJsYWNrIi8+CiAgICAgIDxyZWN0IG9wYWNpdHk9IjAuMSIgeD0iMTEiIHk9IjU0MCIgd2lkdGg9IjM0NiIgaGVpZ2h0PSIxMiIgZmlsbD0iYmxhY2siLz4KICAgICAgPHJlY3Qgd2lkdGg9IjQ3OCIgaGVpZ2h0PSI0NzkiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgNDc5KSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgogICAgICA8cGF0aCBvcGFjaXR5PSIwLjgiIGQ9Ik00NTEuMjc5IDBMMTI1IDQ3OUg0NzhWMEg0NTEuMjc5WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyKSIvPgogICAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIyMzkiIHkxPSIwIiB4Mj0iMjM5IiB5Mj0iNDc5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjREMwNTJEIi8+CiAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM3NjIzMkYiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhciIgeDE9IjQ0NC43OTIiIHkxPSIxLjY5OTk0ZS0wNSIgeDI9IjIwOC4xNjYiIHkyPSIzMjYuOTM1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNzYyMzJGIi8+CiAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNEQzA1MkQiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICA8L2RlZnM+CiAgPC9zdmc+' />
</div>
`;

const svgFeedBackground = `
<div class="social-embed__placeholder--tagboard">
  <svg width='100%' height="100%" viewBox='0 0 1021 270' fill='none' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio="none">
    <rect width='1020' height='270' transform='matrix(1 0 0 -1 0 270)' fill='url(#paint0_linear)'/>
    <path opacity='0.8' d='M591 0L431 270H1021V0H591Z' fill='url(#paint1_linear)'/>
    <defs>
      <linearGradient id='paint0_linear' x1='510' y1='0' x2='510' y2='270' gradientUnits='userSpaceOnUse'>
        <stop stop-color='#DC052D'/>
        <stop offset='1' stop-color='#76232F'/>
      </linearGradient>
      <linearGradient id='paint1_linear' x1='986.922' y1='-0.000342271' x2='890.514' y2='242.492' gradientUnits='userSpaceOnUse'>
        <stop stop-color='#76232F'/>
        <stop offset='1' stop-color='#DC052D'/>
      </linearGradient>
    </defs>
  </svg>
</div>
`;

function buildTemplate({
  empty,
  callToAction,
  privacyNotes,
  icon,
  error,
  callToRetry
}: TemplateOptions) {
  return `
    <div data-cache style='visibility: hidden; overflow: hidden; height: 1px;'></div>
    <div data-content class="social-embed--${icon}">
      ${empty ? '' : `
        <div class="social-embed__wrapper">
          ${icon === 'tagboard' ? svgFeedBackground : svgBackground}

          <div class='social-embed__content'>
            <button class='social-embed__call-to-action'>${error ? callToRetry : callToAction}</button>
            <p class='social-embed__privacy'>${generateLink(privacyNotes)}</p>
          </div>
          <div class='social-embed__icon'>
              ${getIcon(icon)}
          </div>
        </div>
      `
      }
    </div>
  `;
}

function getIcon(id: SupportedPlugins) {
  switch (id) {
    case 'facebook':
      return icons.FacebookSvg;
    case 'twitter':
      return icons.TwitterSvg;
    case 'instagram':
      return icons.InstagramSvg;
    case 'youtube':
      return icons.YoutubeSvg;
    case 'giphy':
      return icons.GiphySvg;
    case 'tagboard':
      return `
      ${icons.TwitterSvg}
      ${icons.InstagramSvg}
      ${icons.FacebookSvg}
      `;
    default:
      return '';
  }
}

export function generateContainer(name, element) {
  if (name === 'tagboard') {
    element.classList.add('social-embed--feed');
  }
  element.classList.add('social-embed--rendered');
  element.innerHTML = buildTemplate({ empty: true });
}

export function generatePreview(name: SupportedPlugins, element, options: TemplateOptions) {
  const tmplOptions = { ...options, icon: name };

  if (name === 'tagboard') {
    element.classList.add('social-embed--feed');
  }

  element.classList.add('social-embed--rendered');
  element.innerHTML = buildTemplate(tmplOptions);

  const content = element.querySelector('.social-embed__content');
  const button = content.querySelector('button');
  const link = element.querySelector('a[data-open-consents="true"]');

  return { content, button, link };
}

function generateLink(text: String): String {
  const linkRegex = /\[([^\[]+)\]\(([^\)]+)\)/gm;
  return text.replace(linkRegex, (fullLink, linkText, fnName) => {
    if (fnName === 'openUserConsents') {
      return `<a class='social-embed__consents-link' href='#' data-open-consents='true'>${linkText}</a>`;
    }

    return `<a class='social-embed__consents-link' href='${fnName}' target='_blank'>${linkText}</a>`;
  });
}
